var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Types from './types';
var currentMenuItemState = {
    data: null,
};
var currentParentMenuItemState = {
    data: null,
};
var menuItemReducer = function (state, action) {
    if (state === void 0) { state = currentMenuItemState; }
    switch (action.type) {
        case Types.CURRENT_MENU_ITEM_POSITION:
            return __assign(__assign({}, state), { data: action.data });
        default:
            return state;
    }
};
var parentMenuItemReducer = function (state, action) {
    if (state === void 0) { state = currentParentMenuItemState; }
    switch (action.type) {
        case Types.CURRENT_PARENT_MENU_ITEM_POSITION:
            return __assign(__assign({}, state), { data: action.data });
        default:
            return state;
    }
};
var HeaderReducer = {
    currentMenuItem: menuItemReducer,
    currentParentMenuItem: parentMenuItemReducer
};
export var getCurrentMenuItemPosition = function (state) { return (state.currentMenuItem.data || null); };
export var getCurrentParentMenuItemPosition = function (state) { return (state.currentParentMenuItem.data || null); };
export default HeaderReducer;
